export const zLevels = {
  dropdown: 1000,
  sticky: 1020,
  fixed: 1030,
  tooltip: 1040,
  modalBackdrop: 1050,
  modal: 1060,
  popover: 1070,
};

export type ZLevels = keyof typeof zLevels;
